import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import handleClipboard from '@/utils/clipboard';
import { regMobile, regWeChat } from '@/utils/index';
import { editClockStatus } from '@/api/admissionCounseling/myCustomers';
import { getClock, addClock } from '@/api/admissionCounseling/myCustomers';
import store from '@/store';
var moment = require('moment');
export default {
  name: 'Clock',
  data: function data() {
    return {
      timerId: null,
      id: null,
      name: '',
      contactPhone: [],
      contactWechat: [],
      customerId: null,
      dialogVisible: true,
      newTimerId: null
    };
  },
  methods: {
    close: function close() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var isCloseClock, id, timerId, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              isCloseClock = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
              // 点击确认需要关闭闹钟
              id = _this.id, timerId = _this.timerId; // id,闹钟id
              _t = isCloseClock;
              if (!_t) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return editClockStatus(id, {
                status: 0
              });
            case 1:
              _this.dialogVisible = false;
              clearTimeout(timerId);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    alarmAgain: function alarmAgain(time) {
      var _this2 = this;
      var data = {
        status: 1,
        // 开
        revisitTime: moment().add(time, 'minutes').format('YYYY-MM-DD HH:mm:ss')
      };
      // 设置闹钟
      addClock(this.customerId, data).then(function () {
        _this2.newTimerId = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var $alarm, id, name, phone, weChat, customerId, res;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                $alarm = _this2.$alarm, id = _this2.id, name = _this2.name, phone = _this2.phone, weChat = _this2.weChat, customerId = _this2.customerId; // 判断闹钟状态
                _context2.n = 1;
                return getClock({
                  cId: customerId,
                  id: store.state.user.user.id
                });
              case 1:
                res = _context2.v;
                if (res.status) {
                  $alarm({
                    timerId: _this2.newTimerId,
                    id: id,
                    name: name,
                    phone: phone,
                    weChat: weChat,
                    customerId: customerId
                  });
                }
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        })), time * 60 * 1000);
        _this2.close(false);
      });
    },
    copy: function copy(text, event) {
      handleClipboard(text, event);
    },
    encrypt: function encrypt(type, val) {
      // 0-手机中间四位*，1-微信中间两位*
      if (!type) {
        return regMobile(val);
      } else {
        return regWeChat(val);
      }
    }
  }
};